import React from "react";
import { useSearchParams } from "react-router-dom";
import AudioLayout from "../AudioLayout";
import { Headphones } from "lucide-react";

export default function AudioLogin() {
  const [params] = useSearchParams();
  const next = params.get("next") || "/audio-comics/books";

  const googleLogin = () => {
    const API = process.env.REACT_APP_BACKEND_URL;
    window.location.href = `${API}/api/audio/auth/google/login?next=${encodeURIComponent(next)}`;
  };

  return (
    <AudioLayout>
      <section className="max-w-md mx-auto pt-6 pb-10">
        <div className="flex items-center gap-2 text-amber-300 text-[11px] uppercase tracking-[0.25em] mb-4">
          <Headphones size={12}/> Sign in
        </div>
        <h1 className="text-3xl sm:text-4xl font-bold leading-tight">Welcome to Bala Basava Audio.</h1>
        <p className="mt-3 text-white/65 text-sm">Sign in with Google to listen to vachanas. Subscribers unlock all 100 stories.</p>

        <div className="mt-8 rounded-2xl bg-white/[0.03] border border-white/10 p-7">
          <button onClick={googleLogin} className="w-full inline-flex items-center justify-center gap-3 px-5 py-3 rounded-full bg-white text-black font-semibold hover:bg-white/90" data-testid="ac-google-login">
            <svg width="16" height="16" viewBox="0 0 24 24"><path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/><path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/><path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l3.66-2.84z"/><path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/></svg>
            Continue with Google
          </button>
          <p className="mt-4 text-[11px] text-white/40 text-center">By signing in you agree to our content guidelines.</p>
        </div>
      </section>
    </AudioLayout>
  );
}
